
/**
 * @export
 * @enum {string}
 */
export enum SymbolPosition {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT'
}